import { Injectable } from '@angular/core';
import { LoggedUserService, SecurityService } from '@improver/infrastructure/auth-data-layer';
import { EmploymentAccessService } from './employment-access.service';
import { PROJECTS_PERMISSIONS } from '@improver/shared/permissions';

@Injectable({
  providedIn: 'root',
})
export class ProjectsAccessService {
  constructor(
    private loggedUserService: LoggedUserService,
    private employmentAccessService: EmploymentAccessService,
    private securityService: SecurityService
  ) {}

  isOwnProjectExperience(userId: string): boolean {
    return userId && this.loggedUserService.isLoggedUser(userId);
  }

  canViewProjectExperience(): boolean {
    return this.securityService.hasPermission(PROJECTS_PERMISSIONS.PROJECT_VIEW_PROJECTS);
  }

  canManageProjectExperience(companyId: number, employeeId: string, employmentId: number): boolean {
    const companyEmployeeProjectExperience: boolean = !!(employeeId && companyId);

    if (employmentId) {
      const hasPermission = this.employmentAccessService.hasPermissionsToSelectedCompanyEmployeeEmployment(
        [PROJECTS_PERMISSIONS.PROJECT_MANAGE_PROJECT_EXPERIENCE],
        [PROJECTS_PERMISSIONS.PROJECT_MANAGE_OWN_PROJECT_EXPERIENCE],
        employmentId
      );

      if (hasPermission) {
        return hasPermission;
      }
    }

    return companyEmployeeProjectExperience
      ? this.employmentAccessService.hasPermissionsToAnyCompanyEmployeeEmployment(
          [PROJECTS_PERMISSIONS.PROJECT_MANAGE_PROJECT_EXPERIENCE],
          [PROJECTS_PERMISSIONS.PROJECT_MANAGE_OWN_PROJECT_EXPERIENCE],
          companyId,
          employeeId
        )
      : false;
  }
}
